/* eslint-disable */
/* jshint ignore:start */
import jQuery from "jquery";

jQuery(function ($) {
  var isDesktopScreen = windowSize() > 1023, //used on "scroll", we need a variable as windowSize() removes the scrollbar!
    transitionSpeed = 300,
    isMenuAimActive = false; //prevent reattaching menuAim handlers (i.e. $(document).mousemove()) over and over on setupNav()

  const primaryNavigationClass = "primary-navigation";
  const subListLevel2Class = "primary-navigation__sub-list-level-2";
  const panelClass = "primary-navigation__sub-list-panel";
  const panelShownClass = "primary-navigation__sub-list-panel--shown";
  const toggleDownClass = "primary-navigation__list-item--toggled-down";
  const toggleDownDesktopClass =
    "primary-navigation__sub-list-item--toggled-desktop";
  const toggleSubListClass =
    "primary-navigation__sub-list-item--toggled-desktop";
  const btnMobileNav = $(".js-header-mobile-nav");
  const btnSearch = $(".js-search-toggle");
  const btnSearchClass = "js-search-toggle";
  const btnLogin = $(".js-login-toggle");
  const popups = [];
  const isPopup = {};
  const isPopout = {};
  const menuOrientation = {};
  const firstChars = {};
  const firstMenuitem = {};
  const lastMenuitem = {};
  const menuitemGroups = [];

  function windowSize() {
    $("body, html").addClass("no-scroll"); //set class to hide scrollbars to measure the width
    var windowWidth = $(window).width();
    $(".no-scroll").removeClass("no-scroll"); //reset class
    if ($(".primary-navigation--visible").length) {
      $("body, html").addClass("no-scroll"); //set class to hide scrollbars to measure the width
    }
    return windowWidth;
  }
  function isDesktopSize() {
    isDesktopScreen = windowSize() > 1279;
    return isDesktopScreen;
  }
  function isMobileSize() {
    return windowSize() < 779;
  }
  function isTopNavHidden() {
    var navBar = document.querySelector(".primary-header");
    return navBar.classList.contains("primary-header--with-top-nav-hidden");
  }
  function setNavHeight() {
    var minHeight = 0;
    var $level1Li = $(
      ".primary-navigation__list-item.primary-navigation__list-item--toggled-down"
    );
    var $level1Panel = $level1Li.find(".primary-navigation__sub-list-panel");
    var $level2Ul = $level1Li.find(".primary-navigation__sub-list-level-2");
    var $level2Wrapper = $level1Li.find(
      ".primary-navigation__sub-list-wrapper--constrain"
    );
    // var $level2Wrapper = $level1Li.find('.primary-navigation__sub-list-wrapper');
    var $level3Ul = $level2Ul.find(
      ".primary-navigation__sub-list-item-level-2.primary-navigation__sub-list-item--toggled-desktop > .primary-navigation__sub-list"
    );
    var $level4Ul = $level3Ul.find(
      ".primary-navigation__sub-list-item-level-3.primary-navigation__sub-list-item--toggled-desktop > .primary-navigation__sub-list"
    );
    var height = Math.max(
      $level1Panel.outerHeight() || 0,
      $level2Ul.outerHeight() || 0,
      $level3Ul.outerHeight() || 0,
      $level4Ul.outerHeight() || 0
    );
    $level2Wrapper.css({ "min-height": height + "px" });
  }

  var $primaryNavigation = $(".primary-navigation");
  var $primaryNavList = $(".primary-navigation__list");
  function shiftToLevel(level) {
    $primaryNavList.removeClass("primary-navigation__list--level-1");
    $primaryNavList.removeClass("primary-navigation__list--level-2");
    $primaryNavList.removeClass("primary-navigation__list--level-3");
    $primaryNavList.removeClass("primary-navigation__list--level-4");
    $primaryNavList.addClass("primary-navigation__list--level-" + level);
  }
  function closeNav() {
    if ($primaryNavigation?.length) {
      $(".primary-navigation__list-item--toggled-down").removeClass(
        "primary-navigation__list-item--toggled-down"
      );
      $(".primary-navigation__sub-list-panel--shown").removeClass(
        "primary-navigation__sub-list-panel--shown"
      );
      $(".primary-navigation__sub-list-item--toggled-desktop").removeClass(
        "primary-navigation__sub-list-item--toggled-desktop"
      );
      $(".primary-navigation__sub-list-wrapper--constrain").css({
        minHeight: 0,
      });
      const nav = document.querySelector("." + primaryNavigationClass);
      const node = nav.querySelectorAll("[aria-expanded=true]");

      for (let i = 0; i <= node.length; i++) {
        setActiveTab(node[i], false);
      }
    }
  }
  function closeSearch() {
    $(".primary-header__search-container").removeClass(
      "primary-header__search-container--shown"
    );
    $(".js-search-toggle").removeClass("toggled");
  }
  function closeLogin() {
    $(".js-login-toggle").removeClass("toggled");
    $("body").removeClass("login-areas-visible");
  }
  function setupNoScrollForNav() {
    if ($primaryNavigation.hasClass("primary-navigation--visible")) {
      /*$('html,body').animate({
                scrollTop: 0
            }, transitionSpeed);*/
      $("html, body").addClass("no-scroll");
    } else {
      $("html, body").removeClass("no-scroll");
    }
  }

  // Keyboard naviagtion
  const setKeyboardNav = () => {
    windowSize();
    if (isDesktopSize() && $primaryNavigation?.length) {
      const navNode = document.querySelectorAll(".primary-navigation__list");
      let navItems = {};

      for (var i = 0; i < navNode.length; i++) {
        navItems = navNode[i];
      }

      initMenu(navItems, 0);

      return navItems;
    }
    return;
  };
  const getNavOrientation = (node) => {
    let orientation = node.getAttribute("aria-orientation");

    if (!orientation) {
      const role = node.getAttribute("role");

      switch (role) {
        case "menubar":
          orientation = "horizontal";
          break;

        case "menu":
          orientation = "vertical";
          break;

        default:
          break;
      }
    }

    return orientation;
  };
  const isNavHorizontal = (navOrientation) =>
    navOrientation && menuOrientation[navOrientation] === "horizontal";
  const isMenubar = (id) => id && !isPopup[id] && !isPopout[id];
  const getIdFromAriaLabel = (node) => {
    let id = node.getAttribute("aria-label");

    return id?.trim().toLowerCase().replace(" ", "-").replace("/", "-");
  };
  const getMenuId = (node) => {
    let id = false;
    let role = node.getAttribute("role");

    while (node && role !== "menu" && role !== "menubar") {
      node = node.parentNode;
      if (node) {
        role = node.getAttribute("role");
      }
    }

    if (node) {
      id = role + "-" + getIdFromAriaLabel(node);
    }
    return id;
  };
  const getMenu = (item) => {
    let menu = item;
    let role = menu.getAttribute("role");

    while (menu && role !== "menu" && role !== "menubar") {
      menu = menu.parentNode;
      if (menu) {
        role = menu.getAttribute("role");
      }
    }

    return menu;
  };
  const getMenuItems = (node, depth) => {
    let nodes = [];
    let submenus = popups;

    function findMenuitems(node) {
      let flag = null;
      let role = "";

      while (node) {
        flag = true;
        role = node.getAttribute("role");

        if (role) {
          role = role.trim().toLowerCase();
        }

        switch (role) {
          case "menu":
            initMenu(node, depth + 1);
            flag = false;
            break;

          case "menuitem":
            if (node.getAttribute("aria-haspopup") === "true") {
              submenus.push(node);
            }
            nodes.push(node);
            break;

          default:
            break;
        }

        if (
          flag &&
          node.firstElementChild &&
          !["i", "svg", "span"].includes(node.firstElementChild.tagName) &&
          node.firstElementChild.hasAttribute("role")
        ) {
          findMenuitems(node.firstElementChild);
        }
        node = node.nextElementSibling;
      }
    }
    findMenuitems(node.firstElementChild, depth);
    return nodes;
  };
  const initMenu = (nav, depth) => {
    let menuitems = [];
    let navitems = [];
    let menuitem = {};
    let role = "";
    const itemId = getMenuId(nav);
    menuitemGroups[itemId] = [];
    firstChars[itemId] = [];
    firstMenuitem[itemId] = null;
    lastMenuitem[itemId] = null;

    menuitems = getMenuItems(nav, depth);
    menuOrientation[itemId] = getNavOrientation(nav);

    isPopup[itemId] = nav.getAttribute("role") === "menu" && depth === 1;
    isPopout[itemId] = nav.getAttribute("role") === "menu" && depth > 1;

    for (var i = 0; i < menuitems.length; i++) {
      menuitem = menuitems[i];
      role = menuitem.getAttribute("role");

      if (role.indexOf("menuitem") < 0) {
        continue;
      }

      navitems.push(menuitem);
      menuitemGroups[itemId].push(menuitem);
      firstChars[itemId].push(menuitem.textContent.trim().toLowerCase()[0]);

      menuitem.addEventListener("keydown", (e) => {
        onKeydown(e);
      });

      if (!firstMenuitem[itemId]) {
        firstMenuitem[itemId] = menuitem;
      }
      lastMenuitem[itemId] = menuitem;
    }

    menuitems = navitems;
  };
  const setActiveTab = (item, value) =>
    item?.setAttribute("aria-expanded", value);
  const hasPopup = (item) => item?.getAttribute("aria-haspopup") === "true";
  const isOpen = (item) => item?.getAttribute("aria-expanded") === "true";
  const openPopup = (item) => {
    let submenu = item.nextElementSibling;
    let role = "";

    if (submenu) {
      role = submenu.getAttribute("role");

      if (!role || role != "menu") {
        submenu = submenu.querySelector('[role="menu"]');
      }

      setActiveTab(item, true);
      submenu.parentElement.classList.add(toggleSubListClass);
      return getMenuId(submenu);
    }

    return false;
  };
  const closePopup = (item) => {
    let menu = "";
    let menuId = getMenuId(item);
    let menuItem = item;

    if (isMenubar(menuId)) {
      if (isOpen(item)) {
        closeNav();
      }
    } else {
      menu = getMenu(item);
      if (menu.classList.contains(subListLevel2Class)) {
        menuItem = menu.closest(
          ".primary-navigation__sub-list-wrapper"
        ).previousElementSibling;
      } else {
        menuItem = menu.previousElementSibling;
      }
      setActiveTab(menuItem, false);
      menuItem.focus();
      if (menu.classList.contains(subListLevel2Class)) {
        closeNav();
      } else {
        menu.parentElement.classList.remove(toggleSubListClass);
      }
    }

    return menuItem;
  };
  const closePopout = (item) => {
    let menu = "";
    let menuId = getMenuId(item);
    let menuItem = item;

    while (isPopup[menuId] || isPopout[menuId]) {
      menu = getMenu(menuItem);

      if (menu.classList.contains(subListLevel2Class)) {
        menuItem = menu.closest(
          ".primary-navigation__sub-list-wrapper"
        ).previousElementSibling;
      } else {
        menuItem = menu.previousElementSibling;
      }

      menuId = getMenuId(menuItem);
      closeNav();
    }
    menuItem.focus();

    return menuItem;
  };
  const closeAllPopups = (item) => {
    if (typeof menuitem !== "object") {
      menuitem = false;
    }
    for (let i = 0; i < popups.length; i++) {
      const popup = popups[i];
      if (doesNotContain(popup, item) && isOpen(popup)) {
        closeNav();
      }
    }
  };
  const isAnyPopupOpen = () => {
    for (let i = 0; i < popups.length; i++) {
      if (popups[i].getAttribute("aria-expanded") === "true") {
        return true;
      }
    }
    return false;
  };
  const doesNotContain = (popup, item) => {
    if (item) {
      return !popup.nextElementSibling.contains(item);
    }
    return true;
  };
  const setFocusToMenuitem = (id, newItem) => {
    closeAllPopups(newItem);
    if (!menuitemGroups[id]) {
      return;
    }
    menuitemGroups[id].forEach((item) => {
      if (item === newItem) {
        newItem.focus();
      }
    });
  };
  const setFocusToFirstMenuitem = (id) => {
    setFocusToMenuitem(id, firstMenuitem[id]);
  };
  const setFocusToNextMenuitem = (id, currentItem) => {
    let newMenuitem = "";
    let index = "";

    if (currentItem === lastMenuitem[id]) {
      newMenuitem = firstMenuitem[id];
    } else {
      index = menuitemGroups[id].indexOf(currentItem);
      newMenuitem = menuitemGroups[id][index + 1];
    }
    setFocusToMenuitem(id, newMenuitem);

    return newMenuitem;
  };
  const setFocusToPreviousMenuitem = (id, currentItem) => {
    let newMenuitem = "";
    let index = "";

    if (currentItem === firstMenuitem[id]) {
      newMenuitem = lastMenuitem[id];
    } else {
      index = menuitemGroups[id].indexOf(currentItem);
      newMenuitem = menuitemGroups[id][index - 1];
    }

    setFocusToMenuitem(id, newMenuitem);

    return newMenuitem;
  };
  const setFocusToLastMenuitem = (id) => {
    setFocusToMenuitem(id, lastMenuitem[id]);
  };
  const setFocusByFirstCharacter = (id, currentItem, char) => {
    let start = "";
    let index = null;

    char = char.toLowerCase();

    start = menuitemGroups[id].indexOf(currentItem) + 1;
    if (start >= menuitemGroups[id].length) {
      start = 0;
    }

    index = getIndexFirstChars(id, start, char);

    if (index === -1) {
      index = getIndexFirstChars(id, 0, char);
    }

    if (index > -1) {
      setFocusToMenuitem(id, menuitemGroups[id][index]);
    }
  };
  const getIndexFirstChars = (id, index, char) => {
    for (let i = index; i < firstChars[id].length; i++) {
      if (char === firstChars[id][i]) {
        return i;
      }
    }
    return -1;
  };
  const isPrintableCharacter = (phrase) =>
    phrase?.length === 1 && phrase.match(/\S/);

  const onKeydown = (e) => {
    const item = e.currentTarget;
    const key = e.key;
    let popupId = null;
    let navItem = "";
    let newItemId = "";
    let newItemFocus = "";
    const itemId = getMenuId(item);

    switch (key) {
      case " ":
      case "Enter":
        if (isNavHorizontal(itemId)) {
          if (hasPopup(item)) {
            popupId = openPopup(item);
            setFocusToFirstMenuitem(popupId);
          }
        }
        break;

      case "ArrowUp":
      case "Up":
        e.preventDefault(); // to prevent website scroll
        if (isNavHorizontal(itemId)) {
          if (hasPopup(item)) {
            popupId = openPopup(item);
            setFocusToLastMenuitem(popupId);
          }
        } else {
          setFocusToPreviousMenuitem(itemId, item);
        }
        break;

      case "ArrowDown":
      case "Down":
        e.preventDefault(); // to prevent website scroll
        if (isNavHorizontal(itemId)) {
          if (hasPopup(item)) {
            popupId = openPopup(item);
            setFocusToFirstMenuitem(popupId);
          } else {
            setFocusToNextMenuitem(itemId, item);
          }
        } else {
          setFocusToNextMenuitem(itemId, item);
        }
        break;

      case "ArrowRight":
      case "Right":
        if (isNavHorizontal(itemId)) {
          navItem = setFocusToNextMenuitem(itemId, item);
          if (isAnyPopupOpen()) {
            openPopup(item);
          }
        } else {
          if (hasPopup(item)) {
            popupId = openPopup(item);
            setFocusToFirstMenuitem(popupId);
          } else {
            navItem = closePopout(item);
            newItemId = getMenuId(navItem);
            newItemFocus = setFocusToNextMenuitem(newItemId, navItem);
            openPopup(newItemFocus);
          }
        }
        break;

      case "ArrowLeft":
      case "Left":
        if (isNavHorizontal(itemId)) {
          navItem = setFocusToPreviousMenuitem(itemId, item);
          if (isAnyPopupOpen()) {
            openPopup(item);
          }
        } else {
          if (isPopout[itemId]) {
            newItem = closePopup(item);
            newItemId = getMenuId(newItem);
            newItemFocus = setFocusToMenuitem(newItemId, newItem);
          } else {
            newItem = closePopup(item);
            newItemId = getMenuId(newItem);
            newItemFocus = setFocusToPreviousMenuitem(newItemId, newItem);
            openPopup(newItemId, newItemFocus);
          }
        }
        break;

      case "Escape":
      case "Esc":
        newItem = closePopup(item);
        newItemId = getMenuId(newItem);
        break;

      case "Home":
      case "PageUp":
        setFocusToFirstMenuitem(itemId, item);
        break;

      case "End":
      case "PageDown":
        setFocusToLastMenuitem(itemId, item);
        break;

      case "Tab":
        closePopup(item);
        break;

      default:
        if (isPrintableCharacter(key)) {
          setFocusByFirstCharacter(itemId, item, key);
        }
        break;
    }
  };

  // Submenu methods
  function openFirstLevel(e) {
    e.preventDefault();
    closeSearch();
    closeLogin();
    const parentEl = e.target.parentElement;
    const isOpenEl = parentEl.classList.contains(toggleDownClass);
    const toggleDownEl = document.querySelector("." + toggleDownClass);
    const toggleDownElDesktop = document.querySelector(
      "." + toggleDownDesktopClass
    );

    setActiveTab(e.target, true);

    toggleDownEl?.classList.remove(toggleDownClass);
    toggleDownElDesktop?.classList.remove(toggleDownDesktopClass);

    if (!isOpenEl) {
      parentEl.classList.add(toggleDownClass);
    }

    const panel = parentEl.querySelector("." + panelClass);
    if (panel) {
      let panelShown = panel.classList.contains(panelShownClass);
      if (!panelShown) {
        setTimeout(() => {
          panel.classList.add(panelShownClass);
        });
      } else {
        document
          .querySelector("." + panelShownClass)
          .classList.remove(panelShownClass);
      }
    } else {
      const panelClosed = document.querySelector("." + panelShownClass);
      panelClosed?.classList?.remove(panelShownClass);
    }
    setNavHeight();
  }

  function setupNav() {
    windowSize();
    if (isDesktopSize()) {
      setNavHeight();
      shiftToLevel(1);
      $(
        ".primary-navigation__list-item--has-children > .primary-navigation__list-item-link"
      ).off("click");
      $(".primary-navigation__sub-list-item-link--back").off("click");
      $(
        ".primary-navigation__sub-list-item--has-children > .primary-navigation__sub-list-item-link"
      ).off("click");
      $(".primary-navigation__list-item--toggled").removeClass(
        "primary-navigation__list-item--toggled"
      );
      $(".primary-navigation__sub-list-item--toggled").removeClass(
        "primary-navigation__sub-list-item--toggled"
      );

      $(
        ".primary-navigation__list-item--has-children .primary-navigation__list-item-link"
      ).click(function (e) {
        openFirstLevel(e);
      });

      if (!isMenuAimActive) {
        isMenuAimActive = true; //prevent reattaching menuAim handlers over and over on setupNav()
        //Subnav intent - Level 2
        //Clear subnav after enough mouseExit time
        $(".primary-navigation__sub-list-level-2").menuAim({
          activate: function (row) {
            var $level2Li = $(row);
            var $level2Ul = $level2Li.parent();
            var $level3Ul = $level2Li.children(
              ".primary-navigation__sub-list-level-3"
            );
            var $level2A = $level2Li
              .children(".primary-navigation__sub-list-item-link")
              .first();
            $level2Li.addClass(
              "primary-navigation__sub-list-item--toggled-desktop"
            );
            $level2A.attr("aria-expanded", "true");
            setNavHeight();
          },
          deactivate: function (row) {
            var $level2Li = $(row);
            var $level2A = $level2Li
              .children(".primary-navigation__sub-list-item-link")
              .first();
            $level2Li.removeClass(
              "primary-navigation__sub-list-item--toggled-desktop"
            );
            $level2A.attr("aria-expanded", "false");
            var $level2Ul = $level2Li.parent();
            setNavHeight();
          },
          exitMenu: function (row) {
            return true;
          },
          rowSelector: "> li",
          submenuSelector: ".primary-navigation__sub-list-item--has-children",
          submenuDirection: "right",
        });
        // level 3
        $(".primary-navigation__sub-list-level-3").menuAim({
          activate: function (row) {
            var $level3Li = $(row);
            var $level3Ul = $level3Li.parent();
            var $level3A = $level3Li
              .children(".primary-navigation__sub-list-item-link")
              .first();
            var $level2Ul = $level3Ul.closest(
              ".primary-navigation__sub-list-level-2"
            );
            var $level4Ul = $level3Li.children(
              ".primary-navigation__sub-list-level-4"
            );
            $level3A.attr("aria-expanded", "true");
            $level3Li.addClass(
              "primary-navigation__sub-list-item--toggled-desktop"
            );
            setNavHeight();
          },
          deactivate: function (row) {
            var $level3Li = $(row);
            var $level3Ul = $level3Li.parent();
            var $level3A = $level3Li
              .children(".primary-navigation__sub-list-item-link")
              .first();
            var $level2Ul = $level3Ul.closest(
              ".primary-navigation__sub-list-level-2"
            );
            $level3A.attr("aria-expanded", "false");
            $level3Li.removeClass(
              "primary-navigation__sub-list-item--toggled-desktop"
            );
            setNavHeight();
          },
          rowSelector: "> li",
          exitMenu: function (row) {
            return true;
          },
          submenuSelector: ".primary-navigation__sub-list-item--has-children",
          submenuDirection: "right",
        });
      }
    } else {
      setupNoScrollForNav();
      shiftToLevel(1);
      $(
        ".primary-navigation__list-item--has-children .primary-navigation__list-item-link"
      ).off("click");
      $(
        ".primary-navigation__list-item--has-children > .primary-navigation__list-item-link"
      ).click(function (e) {
        e.preventDefault();
        var $li = $(this).parent();
        $li.addClass("primary-navigation__list-item--toggled");
        shiftToLevel(2);
      });
      $(".primary-navigation__sub-list-item-link--back").click(function (e) {
        e.preventDefault();
        var link = this;
        var level = $(link)
          .closest(".primary-navigation__sub-list")
          .data("level");
        shiftToLevel(level - 1);
        setTimeout(function () {
          var $sublistItemToggled = $(link).closest(
            ".primary-navigation__sub-list-item--toggled"
          );
          if ($sublistItemToggled.length) {
            $sublistItemToggled.removeClass(
              "primary-navigation__sub-list-item--toggled"
            );
          } else {
            $(link)
              .closest(".primary-navigation__list-item--toggled")
              .removeClass("primary-navigation__list-item--toggled");
          }
        }, transitionSpeed);
      });
      $(
        ".primary-navigation__sub-list-item--has-children > .primary-navigation__sub-list-item-link"
      ).click(function (e) {
        e.preventDefault();
        var level = $(this)
          .closest(".primary-navigation__sub-list")
          .data("level");
        var $li = $(this).parent();
        $li.addClass("primary-navigation__sub-list-item--toggled");
        shiftToLevel(level + 1);
      });
    }
  }

  var debounceSetupNav = $.debounce(setupNav, 300);
  var debounceSetupStickyNav = $.debounce(setupStickyNav, 300);

  debounceSetupNav();
  debounceSetupStickyNav();

  $(window).on("load resize orientationchange", function () {
    debounceSetupNav();
    debounceSetupStickyNav();
    if (!$(".primary-navigation--always-thin").length) {
      debounceSetupStickyNav();
    }
  });
  $(window).on("load", function () {
    setKeyboardNav();
  });

  $(document).on("click touchend", function (e) {
    if (
      $(e.target).closest("nav").length !== 0 ||
      $(e.target).closest(".js-search-toggle").length !== 0 ||
      $(e.target).hasClass("primary-navigation__sub-list") ||
      $(e.target).hasClass("primary-navigation__list") ||
      $(e.target).closest("primary-navigation__sub-list").length !== 0 ||
      $(e.target).closest("primary-navigation__list").length !== 0 ||
      $(e.target).hasClass("searchform") ||
      $(e.target).closest(".searchform").length !== 0 ||
      $(e.target).closest(".primary-navigation__search").length !== 0 ||
      $(e.target).hasClass("js-login-toggle") ||
      $(e.target).closest(".js-login-toggle").length !== 0 ||
      $(e.target).hasClass("login-areas__list-item-link") ||
      $(e.target).closest(".login-areas__list-item-link").length !== 0
    ) {
      //console.log('Do not close');
    } else {
      closeNav();
      closeSearch();
      closeLogin();
    }
  });

  $("nav").on("touchmove", function (e) {
    e.stopPropagation(); //seems fine without it?
  });

  //Mobile menu
  const toggleNavElement = (
    e,
    isCloseLogin,
    isCloseSearch,
    container,
    containerClass
  ) => {
    e.preventDefault();
    closeNav();
    if (isCloseLogin) {
      closeLogin();
    }
    if (isCloseSearch) {
      closeSearch();
    }
    if (container.length) {
      $(container).toggleClass(containerClass);
    }
  };

  const setMobileNavigation = () => {
    if (
      $(".js-header-mobile-nav i").hasClass(
        "primary-header__mobile-nav-icon-bars"
      )
    ) {
      $(".js-header-mobile-nav i")
        .removeClass("primary-header__mobile-nav-icon-bars")
        .addClass("primary-header__mobile-nav-icon-times");
      $("body, html").addClass("no-scroll"); //set class to hide scrollbars to measure the width
    } else {
      $(".no-scroll").removeClass("no-scroll"); //reset class
      $(".js-header-mobile-nav i")
        .addClass("primary-header__mobile-nav-icon-bars")
        .removeClass("primary-header__mobile-nav-icon-times");
    }
    if ($primaryNavigation.hasClass("primary-navigation--visible")) {
      $primaryNavigation.removeClass("primary-navigation--visible");
    } else {
      $primaryNavigation.addClass("primary-navigation--visible");
    }
    setupNoScrollForNav();
  };

  const setMobileSearch = (e) => {
    toggleNavElement(e, true, false, btnSearchClass, "toggled");
    $(".primary-header__search-container").toggleClass(
      "primary-header__search-container--shown"
    );
    if ($(".primary-header__search-container--shown").length) {
      $(".primary-navigation__search-input").focus();
    }
  };

  if (btnMobileNav.length) {
    btnMobileNav.keydown(function (e) {
      if (e.which == 13) {
        setMobileNavigation();
      }
    });
    btnMobileNav.click(function () {
      setMobileNavigation();
    });
  }

  if (btnSearch.length) {
    btnSearch.keydown(function (e) {
      if (e.which == 13) {
        setMobileSearch(e);
      }
    });
    btnSearch.click(function (e) {
      setMobileSearch(e);
    });
  }

  if (btnLogin.length) {
    btnLogin.keydown(function (e) {
      if (e.which == 13) {
        toggleNavElement(e, false, true, "body", "login-areas-visible");
      }
    });
    btnLogin.click(function (e) {
      toggleNavElement(e, false, true, "body", "login-areas-visible");
    });
  }

  debounceSetupNav();
  debounceSetupStickyNav();

  // Sticky header
  function setupStickyNav() {
    isDesktopSize();
    stickyNav();
  }
  function stickyNav() {
    var $navContainer = $(".primary-navigation");

    if ($navContainer.length) {
      var $headerContainer = $(".primary-header");
      var $searchContainer = $(".primary-header__search-container");
      var scrollOffset = $(window).scrollTop();
      if (isDesktopScreen) {
        $(".no-scroll").removeClass("no-scroll"); //reset class
        //if (scrollOffset > $headerContainer.outerHeight()) {
        if (scrollOffset > 120) {
          $headerContainer.addClass("primary-header--fixed");
          $navContainer.addClass("primary-navigation--fixed");
          if (isTopNavHidden()) {
            $searchContainer.addClass(
              "primary-header__search-container--with-top-nav-hidden-and-thin-nav"
            );
            $searchContainer.removeClass(
              "primary-header__search-container--with-top-nav-hidden"
            );
          } else {
            $searchContainer.addClass(
              "primary-header__search-container--fixed"
            );
          }
        } else {
          $headerContainer.removeClass("primary-header--fixed");
          $navContainer.removeClass("primary-navigation--fixed");
          if (isTopNavHidden()) {
            $searchContainer.addClass(
              "primary-header__search-container--with-top-nav-hidden"
            );
            $searchContainer.removeClass(
              "primary-header__search-container--with-top-nav-hidden-and-thin-nav"
            );
          } else {
            $searchContainer.removeClass(
              "primary-header__search-container--fixed"
            );
          }
        }
      } else {
        if (scrollOffset > 0) {
          $headerContainer.addClass("primary-header--fixed");
          $navContainer.addClass("primary-navigation--fixed");
          $searchContainer.addClass("primary-header__search-container--fixed");
        } else {
          $headerContainer.removeClass("primary-header--fixed");
          $navContainer.removeClass("primary-navigation--fixed");
          $searchContainer.removeClass(
            "primary-header__search-container--fixed"
          );
        }
      }
    }
  }

  if (!$(".primary-navigation--always-thin").length) {
    $(window).scroll(stickyNav);
  } else {
    $(".main-area").addClass("main-area--with-nav-fixed-thin");
  }
}); //jQuery
/* jshint ignore:end */
